import { useSession, UseSessionOptions } from 'next-auth/react'
import { useFeatureFlags } from 'components/FeatureFlagProvider/FeatureFlagProvider'

/**
 * Wrapps useSession to make it work with the feature flag. We loose some type information
 * when required is set to true, since we do not have a session when feature flag is disabled.
 *
 * This function may be removed and replaced by useSession(options) when we remove the feature flag
 */
const useSessionWithFeatureFlag = (
  options: UseSessionOptions<boolean> = { required: false },
) => {
  const { featureFlags: flags } = useFeatureFlags()
  if (!flags.loginEnabled) {
    options.required = false
  }

  return useSession(options)
}

export default useSessionWithFeatureFlag
